import { FormStyleContext } from "@common/contexts/FormStyle";
import React from "react";

type Props = {
  error: string;
  qa?: string;
  name: string;
};
const FormFieldError = (props: Props) => {
  const styleContext = React.useContext(FormStyleContext);

  return (
    <div
      data-name={(props.qa ?? props.name) + "Error"}
      className="form_field_error error"
      style={{ fontSize: styleContext?.fieldStyle?.fontSize }}
    >
      <span className="message">{props.error}</span>
    </div>
  );
};
export default FormFieldError;
